import { FunctionComponent, ReactNode } from 'react';

interface IIfProps {
  condition: any;
  children: ReactNode;
}

export const If: FunctionComponent<IIfProps> = ({ condition, children }) => <>{Boolean(condition) && children}</>;
